import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import EditorJSSingle from "../../../components/admin/usable/EditorJSSingle";
import AddButton from "../../../components/admin/usable/AddButton";
import {
  setForAll,
  setIsSingleSelected,
  setShowFileUploader,
  setSingleSelected,
} from "../../../redux/admin/fileManagerSlice";
import FileUploadandSelect from "../../../components/admin/usable/fileuploader/FileUploadandSelect";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { getCouponList } from "../../../api/admin/couponApi";
import { addOffer } from "../../../api/admin/offerApi";

const AddOffers = () => {
  const navigate = useNavigate();
  const [content, setContent] = useState("");
  const [Description, setDescription] = useState("");

  const [CouponData, setCouponData] = useState([]);
  const { showFileUploader, singleSelected } = useSelector(
    (state) => state.file,
  );
  const [FormData, setFormData] = useState({
    offerTitle: "",
    shortDescription: "",
    description: "",
    couponId: "",
    category: "",
    termsAndConditions: "",
    featuredImage: "",
    coverImage: "",
    isFeatured: 0,
    status: 0,
    reatedAt: "",
    createdBy: "",
    createdAt: new Date().toISOString(),
  });
  const dispatch = useDispatch();
  const [activeUploadField, setActiveUploadField] = useState(null);
  useEffect(() => {
    dispatch(setForAll(true));
    dispatch(setIsSingleSelected(true));
    getCouponList(setCouponData);

    return () => {
      dispatch(setForAll(false));
      dispatch(setIsSingleSelected(false));
    };
  }, [dispatch]);
  useEffect(() => {
    if (singleSelected && activeUploadField === "featuredImage") {
      setFormData((prevData) => ({
        ...prevData,
        [activeUploadField]: singleSelected.fileLink.medium || "",
      }));
      setActiveUploadField(null);
      dispatch(setSingleSelected(null));
    }
    if (singleSelected && activeUploadField === "coverImage") {
      setFormData((prevData) => ({
        ...prevData,
        [activeUploadField]: singleSelected.fileLink.medium || "",
      }));
      setActiveUploadField(null);
      dispatch(setSingleSelected(null));
    }
  }, [dispatch, singleSelected, activeUploadField]);
  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      termsAndConditions: content,
      description: Description,
    }));
  }, [content, Description]);
  const handleShowFileManager = (field) => {
    setActiveUploadField(field);
    dispatch(setShowFileUploader(true));
    dispatch(setForAll(true));
  };
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };
  const handleSubmit = () => {
    if (FormData.offerTitle === "") {
      toast.error("Please fill all the required fields");
    } else {
      addOffer(FormData, setFormData, navigate);
    }
  };
  return (
    <>
      {showFileUploader && <FileUploadandSelect />}
      <div className="w-full space-y-5">
        <div className="flex  justify-between items-center">
          <p className="font-bold text-black text-lg">Create A Offer</p>
          <AddButton onClick={handleSubmit} text="Add offer" />
        </div>
        <div className="flex lg:flex-row flex-col gap-3">
          <div className="flex-1 border p-3 bg-white rounded-lg">
            <div>
              <label className="text-xs">Offer Title</label>

              <input
                type="text"
                className="w-full px-4 py-3 rounded-lg border focus:outline-none mb-3"
                placeholder="Offer Title"
                id="offerTitle"
                value={FormData.offerTitle}
                onChange={handleChange}
              />
            </div>
            <div>
              <label className="text-xs">Short Description</label>
              <textarea
                type="text"
                className="w-full px-4 py-3 rounded-lg border focus:outline-none mb-3"
                placeholder="Write a short description..."
                id="shortDescription"
                value={FormData.shortDescription}
                onChange={handleChange}
              />
            </div>
            <div className="flex-1 min-w-0 rounded-lg break-words mb-3">
              <label className="text-xs">Description</label>

              <EditorJSSingle
                content={Description}
                setContent={setDescription}
              />
            </div>
            <div className="flex-1 min-w-0 rounded-lg break-words">
              <label className="text-xs">Terms and Condtion</label>

              <EditorJSSingle content={content} setContent={setContent} />
            </div>
          </div>
          <div className="w-full lg:w-[300px] flex-shrink-0">
            <div className=" border p-3 bg-white rounded-lg space-y-5">
              <div>
                <label className="text-xs">Status</label>
                <select
                  className="w-full px-4 py-2 text-sm rounded-lg border focus:outline-none mb-3"
                  id="status"
                  value={FormData.status}
                  onChange={handleChange}
                >
                  <option value="">Select Status</option>
                  <option value="1">Published</option>
                  <option value="0">Unpublished</option>
                </select>
              </div>
              <div>
                <label className="text-xs">Is Featured?</label>
                <select
                  className="w-full px-4 py-2 text-sm rounded-lg border focus:outline-none mb-3"
                  id="isFeatured"
                  value={FormData.isFeatured}
                  onChange={handleChange}
                >
                  <option value="">Select featured</option>
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </select>
              </div>
              <div>
                <label className="text-xs">Select Coupon</label>
                <select
                  className="w-full px-4 py-2 text-sm rounded-lg border focus:outline-none mb-3"
                  id="couponId"
                  value={CouponData.find(
                    (coupon) => coupon.id === FormData.couponId,
                  )}
                  onChange={handleChange}
                >
                  <option value="">Select Coupon</option>

                  {CouponData.map((item, index) => {
                    return (
                      <option value={item.id} key={index}>
                        {item.code} ({item.expirationDate.split("T")[0]})
                      </option>
                    );
                  })}
                </select>
              </div>
              <div>
                <label className="text-xs">Category</label>
                <select
                  className="w-full px-4 py-2 text-sm rounded-lg border focus:outline-none mb-3"
                  id="category"
                  value={FormData.category}
                  onChange={handleChange}
                >
                  <option value="">Select category</option>
                  <option value="Hotel">Hotel</option>
                  <option value="Tour">Tour</option>
                </select>
              </div>
              <div>
                <label className="text-xs">Featured Image</label>
                <div className="relative">
                  <img
                    className="w-full h-40 object-cover rounded-lg"
                    src={
                      FormData.featuredImage
                        ? FormData.featuredImage
                        : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dSEtDvpd9KAn4SdFJVoL0K1lj4Xfc-wVWQ&s"
                    }
                    alt=""
                  />
                  <div
                    onClick={() => handleShowFileManager("featuredImage")}
                    className="opacity-0 hover:opacity-100 absolute inset-0 bg-black/20 px-3 py-1 border cursor-pointer flex justify-center items-center duration-300 rounded-lg"
                  >
                    <p className="font-bold">Upload Now</p>
                  </div>
                </div>
              </div>
              <div>
                <label className="text-xs">Cover Image</label>
                <div className="relative">
                  <img
                    className="w-full h-40 object-cover rounded-lg"
                    src={
                      FormData.coverImage
                        ? FormData.coverImage
                        : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dSEtDvpd9KAn4SdFJVoL0K1lj4Xfc-wVWQ&s"
                    }
                    alt=""
                  />
                  <div
                    onClick={() => handleShowFileManager("coverImage")}
                    className="opacity-0 hover:opacity-100 absolute inset-0 bg-black/20 px-3 py-1 border cursor-pointer flex justify-center items-center duration-300 rounded-lg"
                  >
                    <p className="font-bold">Upload Now</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddOffers;
